
import { useState, useEffect } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogHeader, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { getNextGameTime, getTimeUntilNextPuzzle } from "@/lib/utils/date-utils";

interface AlreadyPlayedModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onViewResults: () => void;
}

export function AlreadyPlayedModal({ 
  open, 
  onOpenChange,
  onViewResults
}: AlreadyPlayedModalProps) {
  const [nextPuzzleTime, setNextPuzzleTime] = useState<string>("");
  
  useEffect(() => {
    const updateCountdown = () => {
      const { hours, minutes } = getTimeUntilNextPuzzle();
      
      if (hours === 0 && minutes === 0) {
        setNextPuzzleTime("Available now!");
        return;
      }
      
      setNextPuzzleTime(`${hours}h ${minutes}m`);
      
      // Log for debugging
      console.log("Modal countdown update:", { hours, minutes });
    };

    updateCountdown();
    const interval = setInterval(updateCountdown, 60000); // Update every minute
    
    return () => clearInterval(interval);
  }, []);

  const handleViewResultsClick = () => {
    console.log("View results button clicked");
    onViewResults();
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <AlertDialogTitle className="text-center">
            You've already played today!
          </AlertDialogTitle>
          <AlertDialogDescription className="text-center">
            <div className="flex flex-col items-center gap-2 py-2">
              <Clock className="h-6 w-6 text-gray-500" />
              <div className="font-semibold text-black">
                Next puzzle available in {nextPuzzleTime}
              </div>
              <div className="text-xs text-gray-500">
                (Puzzle resets at midnight Eastern Time)
              </div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex justify-center sm:justify-center">
          <Button 
            onClick={handleViewResultsClick} 
            className="bg-black text-white hover:bg-gray-800"
          >
            See today's result
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
